/**
 * Centralized locale and currency configuration
 * This can be extended or moved to database/environment config in the future
 */

export interface LocaleConfig {
  locale: string;
  currency: string;
  dateFormat: string;
  timeFormat: "12h" | "24h";
  firstDayOfWeek: 0 | 1; // 0 = Sunday, 1 = Monday
}

/**
 * Language to locale configuration mapping
 * Can be overridden per venue if needed
 */
export const LOCALE_CONFIG: Record<string, LocaleConfig> = {
  sv: {
    locale: "sv-SE",
    currency: "SEK",
    dateFormat: "yyyy-MM-dd",
    timeFormat: "24h",
    firstDayOfWeek: 1,
  },
  no: {
    locale: "nb-NO",
    currency: "NOK",
    dateFormat: "dd.MM.yyyy",
    timeFormat: "24h",
    firstDayOfWeek: 1,
  },
  da: {
    locale: "da-DK",
    currency: "DKK",
    dateFormat: "dd-MM-yyyy",
    timeFormat: "24h",
    firstDayOfWeek: 1,
  },
  fi: {
    locale: "fi-FI",
    currency: "EUR",
    dateFormat: "d.M.yyyy",
    timeFormat: "24h",
    firstDayOfWeek: 1,
  },
  de: {
    locale: "de-DE",
    currency: "EUR",
    dateFormat: "dd.MM.yyyy",
    timeFormat: "24h",
    firstDayOfWeek: 1,
  },
  fr: {
    locale: "fr-FR",
    currency: "EUR",
    dateFormat: "dd/MM/yyyy",
    timeFormat: "24h",
    firstDayOfWeek: 1,
  },
  es: {
    locale: "es-ES",
    currency: "EUR",
    dateFormat: "dd/MM/yyyy",
    timeFormat: "24h",
    firstDayOfWeek: 1,
  },
  en: {
    locale: "en-GB",
    currency: "GBP",
    dateFormat: "dd/MM/yyyy",
    timeFormat: "12h",
    firstDayOfWeek: 1,
  },
};

/**
 * Get locale config for a language, with fallback
 */
export function getLocaleConfig(languageCode: string): LocaleConfig {
  return LOCALE_CONFIG[languageCode] || LOCALE_CONFIG.en;
}

/**
 * Currency symbols mapping
 */
export const CURRENCY_SYMBOLS: Record<string, string> = {
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  EUR: "€",
  GBP: "£",
  USD: "$",
  JPY: "¥",
};

/**
 * Get currency symbol
 */
export function getCurrencySymbol(currency: string): string {
  return CURRENCY_SYMBOLS[currency] || currency;
}
